import __request__ from "routing/request";
export function updateConfig(config, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/config", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enabledCount(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/enabled-count", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function paginated(page = 1, per_page = 50, sort = "title", order = "asc", query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/paginated", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function disable(id, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/${id}/disable`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enable(id, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/${id}/enable`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getRequiredPermissions(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/${id}/permissions`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPrompt(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.aiagent/agent-workflow/definitions/${id}/prompt`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
